import Icon from 'components/icons/Icon';

const MoreInfo = props => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <title>More Info</title>
      <g id="info_FILL0_wght400_GRAD0_opsz48 2">
        <circle id="Ellipse 1275" cx="7.99992" cy="7.99992" r="6.33333" stroke="#090708" strokeWidth="0.666667" />
        <g id="Group 1073712920">
          <circle id="Ellipse 1276" cx="7.99992" cy="5.33341" r="0.666667" fill="#090708" />
          <path id="Vector 665" d="M7.99976 8.00024V11.0002" stroke="#090708" strokeWidth="1.16667" strokeLinecap="round" />
        </g>
      </g>
    </Icon>
  );
};

export default MoreInfo;
